"use client";

import createSvgIcon from "./utils/createSvgIcon.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon([/*#__PURE__*/_jsx("path", {
  d: "M22 11V3h-7v3H9V3H2v8h7V8h2v10h4v3h7v-8h-7v3h-2V8h2v3zM7 9H4V5h3zm10 6h3v4h-3zm0-10h3v4h-3z"
}, "0"), /*#__PURE__*/_jsx("path", {
  d: "M7 5v4H4V5zm13 0v4h-3V5zm0 10v4h-3v-4z",
  opacity: ".3"
}, "1")], 'AccountTreeTwoTone');